import { jsx as _jsx } from "react/jsx-runtime";
import { TableContainer } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Table';
import { buildElementStyling } from '../utils';
const RichTextTable = ({ children, value }) => {
    const { className, style } = buildElementStyling({ value });
    return (_jsx(TableContainer, { className: className, style: style, fullWidth: true, children: children }));
};
RichTextTable.displayName = 'RichTextTable';
export default RichTextTable;
//# sourceMappingURL=TableContainer.js.map